export const fetchStates = {
  error: 'error',
  fetching: 'fetching',
  success: 'success',
};
